import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface MascotPanelProps {
  title?: string;
  message: string;
  detailedInfo?: string;
}
export function MascotPanel({
  title = 'Norden zegt:',
  message,
  detailedInfo
}: MascotPanelProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex items-start gap-3" data-id="element-731" data-mp="34c0fue9loxzc">
      <div className="flex-shrink-0" data-id="element-732" data-mp="3e2d1k9t5ix72">
        <div className="w-12 h-12 rounded-full border-2 border-white shadow-sm overflow-hidden bg-blue-50" data-id="element-733" data-mp="3e3ejmy8l4jya">
          <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden Mascot" className="w-full h-full object-cover" data-id="element-734" data-mp="39av07kn7uulk" />
        </div>
      </div>

      <div className="flex-1 bg-white rounded-2xl p-4 shadow-sm border border-gray-100" data-id="element-735" data-mp="ep4v7pxnrnua">
        <p className="text-xs font-bold text-[#007AFF] mb-1" data-id="element-736" data-mp="enbx4z142bxw">{title}</p>
        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-737" data-mp="ip6yu4myerc7">{message}</p>

        {detailedInfo && <div className="mt-2" data-id="element-738" data-mp="ni8g2jamv2yy">
            <button onClick={() => setIsExpanded(!isExpanded)} className="text-xs font-semibold text-[#007AFF] hover:text-[#005FCC] flex items-center transition-colors" data-id="element-739" data-mp="sgjnyohdb3ej">
              {isExpanded ? 'Minder info' : 'Meer info'}
              {isExpanded ? <ChevronUpIcon className="w-3 h-3 ml-1" data-id="element-740" data-mp="4qywtib28zu6" /> : <ChevronDownIcon className="w-3 h-3 ml-1" data-id="element-741" data-mp="4t1v0pmd9z9z" />}
            </button>
            <AnimatePresence data-id="element-742" data-mp="9nyyzi4shig0">
              {isExpanded && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="overflow-hidden" data-id="element-743" data-mp="1g52p8k202fx4">
                  <p className="text-gray-500 text-sm leading-relaxed mt-2 pt-2 border-t border-gray-100" data-id="element-744" data-mp="15d6et4qfo73o">
                    {detailedInfo}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>}
      </div>
    </motion.div>;
}